import {LoadingButton as MuiLoadingButton} from "@mui/lab";
import {Theme} from "@mui/material";
import {SxProps} from "@mui/system";
import {PropsWithChildren} from "react";
import {Colors} from "../colors";
import {getButtonRadius} from "../dynamic-ui";

export interface LoadingButtonTypes extends PropsWithChildren {
  size?: "large" | "small" | "medium" | undefined;
  variant?: "contained" | "text" | "outlined";
  color?: "secondary" | "inherit" | "primary" | "success" | "error" | "info" | "warning" | undefined;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  fullWidth?: boolean;
  onClick?: any;
  type?: "button" | "reset" | "submit" | undefined;
  autoFocus?: boolean;
  onKeyDown?: (event: any) => Promise<void>;
  sx?: SxProps<Theme>;
}

export const LoadingButton = ({
  children,
  size = "large",
  variant = "contained",
  color = "primary",
  fullWidth = true,
  disabled,
  loading,
  className = "LoadingButton",
  onClick,
  autoFocus = false,
  type,
  onKeyDown,
  sx,
}: LoadingButtonTypes) => {
  return (
    <MuiLoadingButton
      className={className}
      size={size}
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      disabled={disabled}
      loading={loading}
      onClick={onClick || null}
      type={type}
      autoFocus={autoFocus}
      onKeyDown={onKeyDown}
      sx={{
        fontWeight: 600,
        borderRadius: getButtonRadius(),
        ...(loading && {
          "&.Mui-disabled": {
            background: Colors.primary._800,
          },
        }),
        ...sx,
      }}
    >
      {children}
    </MuiLoadingButton>
  );
};
